// src/oura/board/links.ts
//
// Shared by the Tracker's screen and its open work parts.

import { ouraHref } from "../nav";

/** A client's Delivery tab, opened on one deliverable when a key is given. */
export const deliveryHref = (businessId: string, key?: string) =>
    `${ouraHref("delivery", { role: "oura-staff", businessId })}${key ? `?d=${encodeURIComponent(key)}` : ""}`;

/** The open work list's columns, from 1024px. */
export const WORK_COLS = "lg:grid lg:grid-cols-[96px_minmax(0,0.9fr)_minmax(0,2fr)_minmax(0,0.7fr)_128px] lg:items-center lg:gap-4";
